<template>
  <div class="group-setup">
    <v-card>
      <v-card-title dark>
        <h3 class="ma-2  orange--text">Service Project Points</h3>
        <v-spacer></v-spacer>
        <h3 class="ma-2  green--text">
          Estimated Points: {{ data.totalEstimationPoints }}
        </h3>
        <v-btn
          v-if="
            data.status !== 'APPROVED' &&
              role === 'CLUBS_PERFORMANCE_EVALUATION'
          "
          color="blue"
          x-small
          dark
          title="Reload"
          @click="reloadPoints()"
        >
          Refresh
        </v-btn>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <v-row v-if="data && data.projectPoints">
        <v-col cols="12" md="12" sm="12">
          <EstimationPoints
            :points="data.projectPoints"
            :total="data.totalEstimationPoints"
            :project="data"
            @update="getProjectPoints()"
          ></EstimationPoints>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import EstimationPoints from "../child/EstimationPoints";
import { ProjectService } from "../../../../services/project-service.js";
import { checkError } from "@/config/errors.js";
export default {
  name: "PointList",
  props: ["data"],
  components: { EstimationPoints },

  data: () => ({
    role: localStorage.getItem("role") || null,
  }),

  mounted() {},

  methods: {
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    getProjectPoints() {
      this.$emit("reload");
    },
    reloadPoints() {
      ProjectService.refreshPoints(this.data.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.status_code == 200) {
            this.$emit("reload");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
  },
};
</script>
